import baseApi from './baseApi';
// Define a service using a base URL and injected endpoints
export const checkoutApi = baseApi
    .enhanceEndpoints({ addTagTypes: ['BillingSummary'] })
    .injectEndpoints({
    endpoints: (builder) => ({
        getPaymentMethod: builder.query({
            query: ({ siteId, userId }) => `/api/sites/${siteId}/users/${userId}/paymentOptions`,
            transformResponse: (paymentInfo) => {
                const { storedBankAccounts = [], storedCreditCards = [] } = paymentInfo;
                storedBankAccounts.forEach((account) => {
                    account.paymentType = 'ACH';
                    account.paymentMethodId = account.storedBankAccountId;
                });
                storedCreditCards.forEach((account) => {
                    account.cardType = 'STORED';
                    account.paymentType = 'CARD';
                    account.paymentMethodId = account.storedCreditCardId;
                });
                return paymentInfo;
            },
        }),
        addCreditCard: builder.mutation({
            query: ({ siteId, userId, body }) => ({
                url: `/api/sites/${siteId}/users/${userId}/creditCards/stored/create`,
                method: 'POST',
                body: body,
            }),
            invalidatesTags: ['CartSummary'],
        }),
        getCartSummary: builder.query({
            query: ({ siteId, userId }) => `/api/cart/sites/${siteId}/users/${userId}/cart/summary`,
            providesTags: ['CartSummary'],
        }),
        deleteCartItem: builder.mutation({
            query: ({ cartItemId, siteDomain }) => ({
                url: `/api/member-portal/${siteDomain}/cart`,
                method: 'DELETE',
                body: {
                    cartItemUuid: cartItemId,
                },
            }),
            invalidatesTags: ['CartSummary', 'Registration'],
        }),
        processCart: builder.mutation({
            query: ({ body, siteId, userId }) => ({
                url: `/api/cart/sites/${siteId}/users/${userId}/cart/process`,
                method: 'POST',
                body: body,
            }),
            invalidatesTags: ['CartSummary', 'Registration'],
        }),
        getPaymentWaiver: builder.query({
            query: ({ siteId }) => `api/sites/${siteId}/waivers`,
            transformResponse: (waivers) => {
                return waivers.find((waiver) => waiver.waiverType === 'PAYMENT');
            },
        }),
        getWaivers: builder.query({
            query: ({ siteId }) => `api/sites/${siteId}waivers`,
        }),
        getBillingSummary: builder.query({
            query: ({ subdomain, selectedPaymentMethodType }) => ({
                url: `/api/member-portal/${subdomain}/checkout/billingSummary?paymentMethod=${selectedPaymentMethodType}`,
                method: 'GET',
            }),
            providesTags: ['BillingSummary'],
        }),
    }),
});
// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useAddCreditCardMutation, useDeleteCartItemMutation, useGetBillingSummaryQuery, useGetCartSummaryQuery, useGetPaymentMethodQuery, useGetPaymentWaiverQuery, useProcessCartMutation, useGetWaiversQuery, } = checkoutApi;
